/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_AmazonInputs */



/**
* | output |
* | --- |
* | "Amazon" |
*
* @param {Voice_Manager_Provider_AmazonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_amazon = /** @type {((inputs?: Voice_Manager_Provider_AmazonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_AmazonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Amazon")
	if (locale === "de") return /** @type {LocalizedString} */ ("Amazonas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Amazzonia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Amazon")
	if (locale === "es") return /** @type {LocalizedString} */ ("Amazonas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("亚马逊")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アマゾン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीरांगना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Amazon")
	return /** @type {LocalizedString} */ ("Amazon")
});